<template>
  <div v-if="caseList && caseList.length" class="case">
    <div class="title">案例</div>
    <div class="content">
      <div v-if="caseList.length<=2">
        <div v-for="(item, index) in caseList" :key="index" class="item-wapper single">
          <img :src="item.coverUrl" alt="">
          <div class="cover">
            <div class="card-title">{{ item.title }}</div>
            <div class="card-text">{{ item.content }}</div>
          </div>
        </div>
      </div>
      <CarouselCard v-else ref="carouselCardRef" :interval="7000" :autoplay="false" height="328px" type="card" arrow="always">
        <CarouselCardItem v-for="(item, index) in caseList" :key="index" :name="`cc_${index}`">
          <div class="item-wapper carousel">
            <img :src="item.coverUrl" alt="">
            <div class="cover">
              <div class="card-title">{{ item.title }}</div>
              <div class="card-text">{{ item.content }}</div>
            </div>
          </div>
        </CarouselCardItem>
      </CarouselCard>
    </div>
  </div>
</template>

<script>
import { CarouselCard, CarouselCardItem } from 'vue-carousel-card'
import 'vue-carousel-card/styles/index.css'
import { getOfficialWebsiteCaseList } from '@/apis/index'
export default {
  name: 'CarouselItem',
  components: {
    CarouselCard,
    CarouselCardItem
  },
  props: {
    title: {
      type: String,
      default: '连锁电商'
    }
  },
  data() {
    return {
      caseList: []
    }
  },
  mounted() {
    getOfficialWebsiteCaseList(this.title).then(res => {
      if (res && res.length) {
        res.forEach(element => {
          element.content = element.content.replace(/<[^<>]+>/g, '')
          element.coverUrl = element.coverUrl || 'https://inews.gtimg.com/newsapp_bt/0/14155745389/1000'
        })
        this.caseList = res
      }
    }).catch(err => {
      this.$message.error(err)
    })
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.case {
  height: 553px;
  margin: 0 auto;
  padding: 60px 0;
  background: url("~@/assets/images/solution/solution_service_caseBg.png") no-repeat;
  .title {
    font-size: 32px;
    color: #fff;
  }
  .content {
    width: 1200px;
    margin: 63px auto 0 auto;
  }
  .item-wapper {
    width: 586px;
    height: 328px;
    margin: 0 5px;
    border-radius: 8px;
    overflow: hidden;
    display: inline-block;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .cover {
      background-color: rgba(0, 0, 0, 0.3);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 10;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      padding: 30px 30px 20px;
      .card-title {
        max-height: 66px;
        overflow: hidden;
        text-overflow: ellipsis;
        // white-space:nowrap;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 24px;
        color: #FFFFFF;
        line-height: 33px;
        margin-top: 20px;
      }
      .card-text {
        display: none;
        font-size: 16px;
        text-align: left;
      }
    }
  }
  .carousel {
    img {
      filter: blur(3px);
    }
  }
}
/deep/ .is-active {
  .cover {
    background-color: unset !important;
  }
  img {
    filter: unset !important;
  }
  .card-title {
    text-align: left !important;
  }
  .cover:hover {
    justify-content: flex-start;
    align-items: flex-start;
    background-color: rgba(0, 0, 0, 0.6) !important;
    .card-text {
      display: block;
      color: #fff;
    }
  }
}
.single {
  .cover:hover {
    justify-content: flex-start;
    align-items: flex-start;
    background-color: rgba(0, 0, 0, 0.6) !important;
    .card-text {
      display: block;
      color: #fff;
    }
  }
}

/deep/ .carousel-card-mask {
  background-color: unset;
  opacity: unset;
}
</style>
